export function urlSafe(name) 
{
  return name.toLowerCase() // Convert to lowercase
  .replace(/ä/g, 'a')
  .replace(/ü/g, 'u')
  .replace(/ö/g, 'o')
  .replace(/[^\w\s-]/g, '') // Remove non-word characters
  .trim()                   // Trim leading/trailing spaces
  .replace(/\s+/g, '-');    // Replace spaces with hyphens
}

